import { render, staticRenderFns } from "./vSwiper.vue?vue&type=template&id=0890f44f&scoped=true&"
import script from "./vSwiper.vue?vue&type=script&lang=js&"
export * from "./vSwiper.vue?vue&type=script&lang=js&"
import style0 from "./vSwiper.vue?vue&type=style&index=0&id=0890f44f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890f44f",
  null
  
)

export default component.exports